<!--
checkbox
用例：
<checkbox value="normal" v-model="userTypeSelection">普通</checkbox>
<checkbox value="group" v-model="userTypeSelection">集团</checkbox>

//-->
<template>
  <div class="checkbox-component">
    <el-checkbox :value="values" :label="value"><span></span></el-checkbox>
    <div class="click-box" @click="_toggleItem"></div>
    <label v-if="!isEmptyObject($slots) || text" class="checkbox-text">{{ text }}<slot></slot></label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'selection',
    event: 'changed'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: 0
    },
    /**
     * 当前绑定的值。v-model 绑定的属性。
     * 1. 如果是多选，那么该值为 array
     * 2. 如果是单选，值为 string
     */
    selection: {
      type: [Array, String],
      default: () => null
    },
    /**
     * 显示的文本，一般建议直接用 slot
     */
    text: {
      type: String,
      default: ''
    },
    // serialize the value(selection) to string with comma as '小明,小红', default is true (array)
    isSerialized: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {}
  },
  computed: {
    checked() {
      return this.values.includes(this.value)
    },
    iconClassName() {
      let classNames = this.checked ? 'checkbox-icon-selected' : 'checkbox-icon-unselected'
      if (this.disabled) {
        classNames = classNames + ' checkbox-disabled'
      }
      return classNames
    },
    values() {
      if ($.isEmptyObject(this.selection)) {
        return []
      }
      return this.isSerialized ? this.selection.split(',') : this.selection
    }
  },
  methods: {
    // events
    _triggerChangedEvent(selection) {
      this.$emit('changed', selection)
    },
    _triggerClickEvent() {
      this.$emit('click')
    },
    _toggleItem() {
      if (this.disabled) return

      let selections = this.values.slice(0)
      if (this.checked) {
        this._removeArrayElem(selections, this.value)
      } else {
        selections.push(this.value)
      }
      this._triggerChangedEvent(this._selectionToValue(selections))
      this._triggerClickEvent()
    },
    _removeArrayElem(array, elem) {
      let index = array.indexOf(elem)
      if (index >= 0) {
        array.splice(index, 1)
      }
    },
    _selectionToValue(selections) {
      if (this.isSerialized) {
        if ($.isEmptyObject(selections)) {
          return null
        } else {
          return selections.join(',')
        }
      } else {
        return selections
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-component {
  cursor: pointer;
  display: inline-block;
  line-height: 20px;
  height: 20px;
  vertical-align: middle;
  overflow: hidden;
  position: relative;
  .click-box {
    z-index: 99;
    position: absolute;
    top: 3px;
    left: 0;
    width: 14px;
    height: 14px;
    background: transparent;
  }
  .checkbox-icon {
    width: 15px;
    height: 15px;
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
    margin-top: 2px;
  }
  .checkbox-icon-unselected {
    background-image: url('/images/icons/checkbox_unselected.svg');
  }
  .checkbox-icon-selected {
    background-image: url('/images/icons/checkbox_selected.svg');
  }

  .checkbox-disabled {
    cursor: not-allowed;
    filter: grayscale(80%);
  }

  .checkbox-text {
    display: initial;
    line-height: 20px;
    margin: 0px;
    margin-left: 2px;
    vertical-align: middle;
  }
}
</style>
